<template>
  <div :class="{ 'form-info__active': withArrow }" class="form-info" @click="handleClick">
    <div class="form-info__title">{{ title }}</div>
    <div class="form-info__info">
      <div :class="{ bolded: bolded }" class="form-info__content">{{ info }}</div>
      <div v-if="withArrow" class="form-info__arrow-icon"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FormInfo",
  props: {
    title: {
      type: String,
      default: ""
    },
    info: {
      type: [String, Number],
      default: ""
    },
    bolded: {
      type: [String, Boolean],
      default: false
    },
    withArrow: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick(event) {
      this.$emit("click", event);
    }
  }
};
</script>
